<header-title [model]="headerTitle"></header-title>

<section class="card mt-4" *ngIf="auditTemplateDetailsModel">
    <header class="card-header">
        <h3 class="text-gray-600"><i class="fas fa-tasks me-2"></i>Audit Template : {{auditTemplateDetailsModel.description}}</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-tasks me-2" aria-hidden="true"></i>Audit Template Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-muted" [routerLink]="['/audit-template', 'audit-template-modules', auditTemplateId]">
                                <i class="fas fa-cubes me-2" aria-hidden="true"></i>Audit Template Modules
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <form *ngIf="auditTemplateDetailsFormGroup" (submit)="updateAuditTemplate()" [formGroup]="auditTemplateDetailsFormGroup">
                <error-message [errors]="errors"></error-message>
                <div class="row mt-3">
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="control-label text-primary">
                                Description
                            </label>
                            <input type="text" class="form-control" formControlName="description" [readOnly]="!isEditMode" />
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="control-label text-primary">
                                Category
                            </label>
                            <input type="text" id="tmp" name="tmp" class="form-control" [readOnly]="true" value="{{categoryString}}" *ngIf="!isEditMode" />
                            <select name="auditCategoryId" class="form-control" formControlName="auditCategoryId" *ngIf="isEditMode">
                                <option *ngFor="let auditCategory of auditCategoryList" [value]="auditCategory.id">{{auditCategory.description}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6 col-lg-4">
                        <label class="control-label text-primary">
                            Is Active
                        </label>
                        <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle [isDisabled]="!isEditMode" />
                    </div>
                    <div class="col-md-3">
                        <label class="control-label text-primary">
                            Recurrence (number of months)
                        </label>
                        <input type="number" id="recurrence" name="recurrence" class="form-control" formControlName="recurrence" [readOnly]="!isEditMode" />
                    </div>
                </div>
                <footer class="panel-footer mt-5">
                    <div class="row">
                        <div class="col-12 text-end">
                            <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                            <button class="btn btn-outline-primary" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                            <button class="btn btn-success ms-1" type="submit" [disabled]="!auditTemplateDetailsFormGroup.valid" *ngIf="isEditMode">Save</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </div>
</section>


<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'Audit Template Updated'">
</app-alert-message>
